import { Component, OnInit, OnDestroy, HostBinding, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { HistoricContextService } from '../historic-context.service';
import * as echarts from 'echarts';
import * as moment from 'moment';
import { split } from 'ts-node';

const ECHART_OPTIONS = {
  xAxis: {
    type: 'category',
    data: [],
    axisLabel: {
      fontFamily: 'Roboto',
      color: '#747474',
      fontSize: 12,
      splitNumber: 1,
      overflow: 'breakAll',
      formatter: (value, index) => ''
    },
    axisTick: {
      interval: 1,
      alignWithLabel: true
    }
  },
  tooltip: {},
  yAxis: {
    splitNumber: 4,
    axisLabel: {
      align: 'right',
      fontFamily: 'Roboto',
      color: '#747474',
      fontSize: 12,
      formatter: function (value, index) {
        return index ? 'Level ' + value : '';
      }
    },
    axisTick: {
      interval: 1,
      alignWithLabel: true
    }
  },
  series: [
    {
      data: [],
      type: 'bar',
      itemStyle: {
        color: '#1785fb'
      }
    }
  ],
};

@Component({
  selector: 'app-historic-detail-level',
  templateUrl: './historic-detail-level.component.html',
  styleUrls: ['./historic-detail-level.component.scss']
})
export class HistoricDetailLevelComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  data = null;
  echart;
  histogram = [];

  constructor(
    private historicContextService: HistoricContextService
  ) {}

  ngOnInit() {
    this.subscription = this.historicContextService.levelDetail$.subscribe((data) => {
      this.data = data;
      if (data) {
        this.historicContextService.getDetailLevel(
          data.ntram,
          moment.utc({
            ...data.date.fromDate,
            month: data.date.fromDate.month - 1,
            hour: (data.date.fromHour || '').split(':')[0],
            minute: (data.date.fromHour || '').split(':')[1],
          }).toISOString(),
          moment.utc({
            ...data.date.toDate,
            day: !data.date.toHour ? data.date.toDate.day + 1 : data.date.toDate.day,
            month: data.date.toDate.month - 1,
            hour: (data.date.toHour || '').split(':')[0],
            minute: (data.date.toHour || '').split(':')[1],
          }).toISOString(),
          data.variable)
        .then((res) => {
          this.histogram = res;
          ECHART_OPTIONS.series[0].data = this.histogram.map(x => x.level);
          ECHART_OPTIONS.xAxis.data = this.histogram.map(x => moment(x.start_ts).format('DD/MM/YYYY HH:mm'));
          ECHART_OPTIONS.xAxis.axisLabel.formatter = (value, index) => {
            const end = moment(this.histogram[index].end_ts).format('DD/MM/YYYY HH:mm');
            return value + '\n' + end;
          };
          ECHART_OPTIONS.tooltip = {
            backgroundColor: '#2c2c2c',
            borderColor: '#2c2c2c',
            textStyle: {
              fontFamily: 'Roboto',
              color: '#ffffff',
              fontSize: 12,
            },
            padding: [3, 8],
            formatter: (params) => {
              const end = moment(this.histogram[params.dataIndex].end_ts).format('DD/MM/YYYY HH:mm');
              return params.name + ' - ' + end;
            },
          },
          this.echart = echarts.init(document.getElementById('chart-detail-level'));
          this.echart.setOption(ECHART_OPTIONS);
        });
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  close () {
    this.historicContextService.levelDetail$.next(null);
  }
}



// WEBPACK FOOTER //
// ./src/app/historic/historic-detail-level/historic-detail-level.component.ts